<!--用车规则列表-->
<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      width="70%"
      title="用车规则"
      class="sp-manager__dialog"
      :visible="show"
      :before-close="beforeCloseDialog"
      @dialogclose="beforeCloseDialog"
      append-to-body
    >
      <div slot="title" class="dialog-header-title">
        <span class="name">用车规则</span>
      </div>
      <div class="add">
        <el-button size="small" @click="showDialog()" icon="el-icon-plus">新增</el-button>
      </div>

      <div class="form_content">
        <div ref="tablePanel" class="fullheight">
          <div class="table_content">
            <el-table
              ref="ecoTable"
              :style="{
                height: `${tableMaxHeight}` + 'px'
              }"
              :max-height="tableMaxHeight"
              :data="templateData"
              tooltip-effect="dark"
              style="width: 100%"
              border
              :header-cell-style="headerCellStyle"
            >
              <el-table-column type="index" label="序号" width="55"> </el-table-column>
              <el-table-column prop="rule_pack_name" label="规则名称" show-overflow-tooltip> </el-table-column>
              <el-table-column prop="rule_pack_no" label="规则ID"> </el-table-column>
              <el-table-column prop="apply_type" label="申请方式">
                <template v-slot="{ row }">
                  <el-tag type="info" v-if="row.apply_type == '201'">按用车次数申请</el-tag>
                  <el-tag type="info" v-if="row.apply_type == '202'">按用车日期申请</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button @click="showUserDialog(scope.row)">分配员工</el-button>
                  <el-button @click="showDialog(scope.row.id)">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="page_bean">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 40, 50, 100, 500]"
                :page-size.sync="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <eco-sidebar-dialog
      destroy-on-close
      width="28%"
      title="企业用车规则维护"
      class="sp-manager__dialog zdyHight"
      :visible="dialogVisible"
      append-to-body
      :before-close="beforeCloseDialog2"
    >
      <el-form v-form data-vv-scope="tenantTypeForm" v-model="tenantType" style="padding: 20px">
        <eco-form-item label="规则名称" label-width="120px">
          <eco-input v-model="tenantType.rule_pack_name" validate="required" autocomplete="off" />
        </eco-form-item>
        <eco-form-item label="规则ID" label-width="120px">
          <eco-input v-model="tenantType.rule_pack_no" validate="required" autocomplete="off" />
        </eco-form-item>
        <eco-form-item label="申请方式" label-width="120px">
          <eco-select v-model="tenantType.apply_type" :options="portalTypeOptions" :props="{ key: 'value', value: 'label' }" :validate="{ required: true }" />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="beforeCloseDialog2">取消</el-button>
        <fe-submit-button :url="saveSysTypeUrl" :model="tenantType" :requestMethod="requestMethod" scope-name="tenantTypeForm" @after-save-data="afterSaveData"
          >保存</fe-submit-button
        >
      </div>
    </eco-sidebar-dialog>
    <eip-user-dialog ref="eipUserDialog" @onConfirm="userDialogOnConfirm" append-to-body :user-type="1" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import form from '@/api/form'
import utils from '@/utils.js'
import uc from '@/api/uc.js'
import EipUserDialog from '@/components/dialog/EipUserDialog.vue'
export default {
  name: 'ycgzListDialog',
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    tempValue: {
      type: Object,
      default: () => {}
    },
    tenantId: {
      type: String,
      default: () => ''
    }
  },
  components: {
    EipUserDialog
  },
  data() {
    return {
      total: 0,
      pageSize: 20,
      currentPage: 1,
      templateData: [],
      boDefIdList: [],
      selectUploadId: null,
      selectModel: null,
      taVisible: false,
      tmVisible: false,
      tableMaxHeight: 400,
      activeName: 'first',
      code: '',
      showNcType: false,
      dialogVisible: false,
      tenantType: {
        id: '',
        rule_pack_name: '',
        rule_pack_no: '',
        apply_type: '',
        user_ids: '',
        user_infos: [],
        user_names: ''
      },
      portalTypeOptions: []
    }
  },
  computed: {
    saveSysTypeUrl: function () {
      return `${window.context.third}/meiTuan/third_sqt_role/`
    },
    ...mapState({
      allDataDict: (state) => state.user.allDataDict,
      allEnumerate: (state) => state.user.allEnumerate
    }),
    requestMethod: function () {
      return this.tenantType.id ? 'PUT' : 'POST'
    }
  },
  mounted() {
    this.loadData()
    let that = this
    that.$nextTick(() => {
      that.portalTypeOptions = utils.getAllEnumerateAttr({
        isShowList: true,
        typeKey: 'SqtRoleApplyType',
        allData: that.allEnumerate
      })
    })
  },
  methods: {
    beforeCloseDialog() {
      this.$emit('closeYcgzList')
    },
    submit() {},
    //表头样式
    headerCellStyle() {
      return {
        textAlign: 'center',
        backgroundColor: '#646464',
        color: '#fff'
      }
    },
    //每页数量调整
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    //页数跳转
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    // 动态计算表格的高度，自适应当前容器
    calcTableHeight(delay) {
      setTimeout(() => {
        if (!this.$refs.tablePanel) {
          return
        }
        const tablePanelHeight = this.$refs.tablePanel.$el.clientHeight
        this.tableMaxHeight = tablePanelHeight - 220
      }, delay || 0)
    },
    //初始化加载
    loadData(prop, sort) {
      let params = {
        pageBean: {
          page: this.currentPage,
          pageSize: this.pageSize,
          total: 0
        }
      }
      if (prop) {
        params.sorter = [{ property: prop, direction: sort }]
      }
      form.getYcgzList(params).then((resp) => {
        this.templateData = resp.rows
        this.total = resp.total
      })
    },

    // 打开新增编辑弹框
    showDialog(id) {
      if (id) {
        // 编辑
        this.$http.get('${third}/meiTuan/third_sqt_role/' + `${id}`).then(
          (resp) => {
            this.tenantType = resp.data
            this.tenantType.apply_type = resp.data.apply_type.toString()
            this.dialogVisible = true
          },
          (error) => {
            reject(error)
          }
        )
      } else {
        this.dialogVisible = true
      }
    },
    // 关闭新增编辑的弹框
    beforeCloseDialog2() {
      this.tenantType = {}
      this.dialogVisible = false
    },
    afterSaveData() {
      setTimeout(() => {
        this.beforeCloseDialog2()
        // this.$refs.ecoTable.load();
        this.loadData()
      }, 500)
    },
    // 分配用户
    showUserDialog(data) {
      this.tenantType.user_infos = []
      this.tenantType.id = data.id
      this.tenantType.rule_pack_name = data.rule_pack_name
      this.tenantType.rule_pack_no = data.rule_pack_no
      let queryFilter = {
        querys: [
          {
            group: 'advanced',
            operation: 'EQUAL',
            property: 'ucuser.STATUS_',
            relation: 'AND',
            value: 1
          },
          {
            property: 'ID_',
            group: 'advanced',
            operation: 'in',
            relation: 'AND',
            value: data.user_ids ? data.user_ids.split(',') : []
          }
        ],
        pageBean: {
          showTotal: true
        }
      }
      this.$http.post('${uc}/api/user/v1/users/queryByType', queryFilter).then((rep) => {
        let data = rep.data
        this.$refs.eipUserDialog.showDialog(data.rows)
      })
    },
    // 分配用户确认弹框
    userDialogOnConfirm(selection) {
      if (!selection || selection.length == 0) {
        this.$message.error('请至少选择一个员工')
        return
      }
      let user_names = []
      let user_ids = []
      for (let user of selection) {
        if (user.id) {
          user_names.push(user.fullname)
          user_ids.push(user.id)
          this.tenantType.user_infos.push({
            user_id: user.id,
            user_name: user.fullname
          })
        }
      }
      this.tenantType.user_names = user_names.join(',')
      this.tenantType.user_ids = user_ids.join(',')
      uc.saveSqtRole(this.tenantType).then((data) => {
        if (data.state) {
          this.$message({
            message: '分配员工成功',
            type: 'success',
            showClose: true
          })
          this.loadData()
          return
        }
        this.$message.error(data.message || '分配员工失败')
      })
    }
  }
}
</script>

<style scoped>
.zdyHight /deep/.el-dialog__body {
  height: calc(100% - 180px) !important;
}
.top_search {
  height: 45px;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.col_style {
  height: 100%;
  display: flex;
  align-items: center;
}
/deep/.el-input-group__append button.el-button {
  border-color: transparent;
  background-color: #377cff;
  color: white;
  border-top: 0;
  border-bottom: 0;
}
.button_group {
  height: 40px;
  display: flex;
  justify-content: right;
  align-items: center;
}
.page_bean {
  display: flex;
  justify-content: right;
  align-items: center;
}
.add {
  display: flex;
  justify-content: end;
  margin-bottom: 10px;
}
</style>
